// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_4f720283bf--wrapper--l1aaZ","discount_price":"_4f720283bf--discount_price--Rg6i0","hint":"_4f720283bf--hint--TDG6c"};